import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { ITriviaRegular } from '../interfaces/trivia.interface';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { User } from '@core/interfaces/user.interface';
import { CostComponent } from '@core/components/cost/cost.component';
import { ContextMenuService } from '@core/services/context-menu.service';
import { TriviaService } from '../trivia.service';
import { ToastrService } from 'ngx-toastr';
import {
  CountdownComponent,
  CountdownEvent,
  CountdownStatus,
} from 'ngx-countdown';
import { sleep } from '@core/utils/sleep.util';

@Component({
  selector: 'app-trivia-regular-widget',
  imports: [
    FormFieldComponent,
    ReactiveFormsModule,
    PlayerRowComponent,
    CostComponent,
    CountdownComponent,
  ],
  templateUrl: './trivia-regular-widget.component.html',
  styleUrl: './trivia-regular-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TriviaRegularWidgetComponent {
  public contextMenuService = inject(ContextMenuService);
  private triviaService = inject(TriviaService);
  private toastrService = inject(ToastrService);

  triviaRegular = input.required<ITriviaRegular>();

  user = computed<User>(() => ({
    name: this.triviaRegular().by,
    avatar: this.triviaRegular().avatar,
    steamid: this.triviaRegular().steamid ?? '',
    level: this.triviaRegular().level ?? 0,
  }));

  answer = new FormControl('', [Validators.required]);
  answerForm = new FormGroup({
    answer: this.answer,
  });

  async onSubmit() {
    if (!this.answerForm.valid) {
      this.toastrService.error('Form is not valid. Please check the inputs.');
      return;
    }

    const answer = this.answerForm.get('answer')?.value;

    if (!answer) {
      this.toastrService.error('Answer is required');
      return;
    }

    await this.triviaService.choiceAnswerTriviaRegular(answer);
  }

  async countDownEvent(event: CountdownEvent) {
    if (event.status === CountdownStatus.done) {
      await sleep(1000);
      this.triviaService.regularTrivia.set(null);
    }
  }
}
